import { push } from "connected-react-router";
import { put, takeEvery } from "redux-saga/effects";
import { AUTH_LOGOUT_REQUEST } from "../../../auth";

export function* logout() {
    yield put(push("/login"));
}

export function* watchLogout() {
    yield takeEvery(AUTH_LOGOUT_REQUEST, logout);
}
